/*eslint-disable*/
import {
  Button,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import EasyRange from "components/EasyRange/EasyRange.jsx";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import SpaceDisplay from "components/SpaceDisplay/SpaceDisplay.jsx";
import { calcDiffInDays } from "helpers/DateHelpers";
import { GetUserId, GetUserToken } from "helpers/UserHelper";
import { SubscriptionInfo } from "queries/Subscription/queries";
import React, { Component } from "react";
import { Query } from "react-apollo";

const pricePlans = {
  Basic: ["CRM Tool", "Client App", "Free Assistant User"],
  Standard: [
    "All Basic package features",
    "Quoting Platform",
    "Astute Integration"
  ],
  Premium: [
    "All Basic + Standard package features",
    "FNA, BNA & Will Generation",
    "Invoice Management"
  ]
};

const PricePlanMap = {
  1: "Basic",
  2: "Standard",
  3: "Premium",
  4: "Trial"
};

const priceTableFirst12 = {
  level1: {
    basic: 395,
    standard: 545,
    premium: 695
  },
  level2: {
    basic: 345,
    standard: 495,
    premium: 625
  },
  level3: {
    basic: 275,
    standard: 415,
    premium: 545
  }
};

const priceTableAfter12 = {
  level1: {
    basic: 595,
    standard: 795,
    premium: 995
  },
  level2: {
    basic: 495,
    standard: 695,
    premium: 895
  },
  level3: {
    basic: 395,
    standard: 595,
    premium: 795
  }
};

class EditSubscription extends Component {
  state = {
    subscriptionInfoInitiated: false,
    priceplanItem: "Standard",
    brokerAmount: 0,
    subscription: {
      currentLevel: 1,
      brokers: {
        basic: 0,
        standard: 0,
        premium: 0
      },
      amounts: {
        basic: 0,
        standard: 0,
        premium: 0
      },
      freeAssistants: 0,
      extraAssistants: 0,
      userPlan: "basic",
      totalPrice: 0.0,
      totalPriceAfter12: 0.0,
      payment: {
        next: "N/A"
      },
      within_twelve_month_period: true,
      twelth_month_date: ""
    },
    currentSubscription: {
      currentLevel: 1,
      brokers: {
        basic: 0,
        standard: 0,
        premium: 0
      },
      amounts: {
        basic: 0,
        standard: 0,
        premium: 0
      },
      freeAssistants: 0,
      extraAssistants: 0,
      userPlan: "basic",
      totalPrice: 0.0,
      totalPriceAfter12: 0.0,
      payment: {
        next: "N/A"
      },
      within_twelve_month_period: true,
      twelth_month_date: ""
    }
  };

  getTotalBrokersForcurrentSubscription = () => {
    let total = 0;
    Object.keys(this.state.currentSubscription.brokers).map(b => {
      total += this.state.currentSubscription.brokers[b];
    });
    return total;
  };

  calculatePackage = (packageName, subscription) => {
    let brokerCount = 0;
    Object.keys(subscription.brokers).map(b => {
      brokerCount += subscription.brokers[b];
    });

    if (brokerCount < 3) {
      subscription.currentLevel = 1;
    } else if (brokerCount < 51) {
      subscription.currentLevel = 2;
    } else {
      subscription.currentLevel = 3;
    }

    let count = subscription.brokers[packageName];

    let am = null;

    if (subscription.within_twelve_month_period) {
      am = priceTableFirst12["level" + subscription.currentLevel][packageName];
    } else {
      am = priceTableAfter12["level" + subscription.currentLevel][packageName];
    }

    subscription.amounts[packageName] = count * am;
    return subscription;
  };

  calculateAmounts = subscription => {
    //Free Assistants calculation
    let total = 0;
    Object.keys(subscription.brokers).map(b => {
      total += subscription.brokers[b];
    });
    subscription.freeAssistants = total;

    //GrandTotal Calculation
    let before12Total = 0.0;
    let after12Total = 0.0;

    Object.keys(subscription.brokers).map(a => {
      before12Total +=
        priceTableFirst12["level" + subscription.currentLevel][a] *
        subscription.brokers[a];

      after12Total +=
        priceTableAfter12["level" + subscription.currentLevel][a] *
        subscription.brokers[a];
    });

    let extraAssistantsTotal = subscription.extraAssistants * 200.0;

    subscription.totalPrice = before12Total + extraAssistantsTotal;
    subscription.totalPriceAfter12 = after12Total + extraAssistantsTotal;

    return subscription;
  };

  brokerAmountChange = (event, packageName) => {
    if (!isNaN(event.target.value) && event.target.value !== "") {
      let subscription = { ...this.state.subscription };
      subscription.brokers[packageName] = parseInt(event.target.value);

      subscription = this.calculatePackage(packageName, subscription);
      subscription = this.calculateAmounts(subscription);
      this.setState({ subscription: subscription });
    }
  };

  brokerPlus = packageName => {
    let subscription = Object.assign(this.state.subscription);
    subscription.brokers[packageName] = subscription.brokers[packageName] + 1;

    subscription = this.calculatePackage(packageName, subscription);
    subscription = this.calculateAmounts(subscription);
    this.setState({ subscription: subscription });
  };

  brokerMinus = packageName => {
    let subscription = { ...this.state.subscription };
    subscription.brokers[packageName] =
      subscription.brokers[packageName] !== 0
        ? subscription.brokers[packageName] - 1
        : 0;

    subscription = this.calculatePackage(packageName, subscription);
    subscription = this.calculateAmounts(subscription);
    this.setState({ subscription: subscription });
  };

  extraAssistantAmountChange = event => {
    if (!isNaN(event.target.value) && event.target.value !== "") {
      let subscription = { ...this.state.subscription };
      subscription.extraAssistants = parseInt(event.target.value);

      subscription = this.calculateAmounts(subscription);
      this.setState({ subscription: subscription });
    }
  };

  extraAssistantsPlus = () => {
    let subscription = { ...this.state.subscription };
    subscription.extraAssistants = subscription.extraAssistants + 1;

    subscription = this.calculateAmounts(subscription);
    this.setState({ subscription: subscription });
  };

  extraAssistantsMinus = () => {
    let subscription = { ...this.state.subscription };
    if (subscription.extraAssistants === 0) return;

    subscription.extraAssistants = subscription.extraAssistants - 1;
    subscription = this.calculateAmounts(subscription);
    this.setState({ subscription: subscription });
  };

  getLevel(subscriptionInfo) {
    const brokerCount =
      subscriptionInfo.sd_basic_brokers +
      subscriptionInfo.sd_standard_brokers +
      subscriptionInfo.sd_premium_brokers;
    if (brokerCount < 3) {
      return 1;
    } else if (brokerCount < 51) {
      return 2;
    } else {
      return 3;
    }
  }

  getPackageAmounts(subscriptionInfo, level) {
    const amounts = {
      basic:
        priceTableFirst12[`level${level}`].basic *
        subscriptionInfo.sd_basic_brokers,
      standard:
        priceTableFirst12[`level${level}`].standard *
        subscriptionInfo.sd_standard_brokers,
      premium:
        priceTableFirst12[`level${level}`].premium *
        subscriptionInfo.sd_premium_brokers
    };

    return amounts;
  }

  getNextDebitOrderAmount = () => {
    const totalPrice = this.state.subscription.totalPrice;

    if (this.state.subscription.payment.next) {
      var nextPaymentDate = new Date(this.state.subscription.payment.next);
      var now = new Date();
      var diffInDays = calcDiffInDays(nextPaymentDate, now);
      var restMonthAmount = totalPrice * (diffInDays / 30);
      return restMonthAmount.toFixed(2);
    } else {
      return totalPrice;
    }
  };

  buildSubscriptionObj = subscriptionInfo => {
    var level = this.getLevel(subscriptionInfo);
    var amounts = this.getPackageAmounts(subscriptionInfo, level);

    let subscriptionObj = {
      currentLevel: level,
      brokers: {
        basic: subscriptionInfo.sd_basic_brokers,
        standard: subscriptionInfo.sd_standard_brokers,
        premium: subscriptionInfo.sd_premium_brokers
      },
      amounts: amounts,
      freeAssistants: subscriptionInfo.sd_free_assistants,
      extraAssistants: subscriptionInfo.sd_extra_assistants,
      userPlan: PricePlanMap[subscriptionInfo.sd_brokerage_user_plan],
      totalPrice: subscriptionInfo.sd_price_pm,
      totalPriceAfter12: 0.0,
      payment: {
        next: subscriptionInfo.sd_next_payment
      },
      within_twelve_month_period: true,
      twelth_month_date: subscriptionInfo.sd_twelth_month_end
    };

    subscriptionObj = this.calculateAmounts(subscriptionObj);
    return subscriptionObj;
  };

  differenceExists = () => {
    return (
      this.state.subscription.brokers.basic !==
        this.state.currentSubscription.brokers.basic ||
      this.state.subscription.brokers.standard !==
        this.state.currentSubscription.brokers.standard ||
      this.state.subscription.extraAssistants !==
        this.state.currentSubscription.extraAssistants
    );
  };

  render() {
    return (
      <Query
        query={SubscriptionInfo}
        variables={{
          userId: GetUserId(),
          token: GetUserToken()
        }}
        fetchPolicy="network-only"
      >
        {({ loading, error, data, refetch }) => {
          if (loading) {
            return <LinearProgress />;
          }

          if (!this.state.subscriptionInfoInitiated) {
            var subscriptionInfo = data.SubscriptionInfo;

            this.setState({
              subscription: { ...this.buildSubscriptionObj(subscriptionInfo) },
              currentSubscription: {
                ...this.buildSubscriptionObj(subscriptionInfo)
              },
              subscriptionInfoInitiated: true
            });
          }
          return (
            <React.Fragment>
              <GridContainer
                style={{
                  maxHeight: "45vh",
                  overflowY: "auto",
                  borderBottom: "1px solid #e2e2e2",
                  boxShadow: "0px 8px 8px -5px rgba(0, 0, 0, 0.14)"
                }}
              >
                <GridItem xs={12} sm={12} md={4} style={{ height: "90%" }}>
                  <Card>
                    <CardHeader>
                      <SpaceDisplay
                        left={
                          <Typography variant="subheading" gutterBottom>
                            Basic
                          </Typography>
                        }
                        right={
                          <Typography variant="caption" gutterBottom>
                            R
                            {
                              priceTableFirst12[
                                "level" + this.state.subscription.currentLevel
                              ]["basic"]
                            }{" "}
                            p/m
                          </Typography>
                        }
                      />
                    </CardHeader>
                    <CardContent>
                      <div style={{ display: "block" }}>
                        <SpaceDisplay
                          style={{
                            borderBottom: "1px solid #cccccc69",
                            paddingBottom: "12px",
                            marginBottom: "10px"
                          }}
                          left={
                            <Typography
                              style={{
                                position: "relative",
                                top: "5px"
                              }}
                            >
                              Amount of brokers:
                            </Typography>
                          }
                          right={
                            <EasyRange
                              number={this.state.subscription.brokers.basic}
                              change={e => this.brokerAmountChange(e, "basic")}
                              plus={() => this.brokerPlus("basic")}
                              minus={() => this.brokerMinus("basic")}
                            />
                          }
                        />
                        <Typography variant="body2" gutterBottom>
                          Includes:
                        </Typography>
                        <Typography>
                          {pricePlans.Basic.slice(0, 3).map(p => {
                            return (
                              <span>
                                {p}
                                <br />
                              </span>
                            );
                          })}
                        </Typography>

                        {pricePlans.Basic.length > 3 ? (
                          <Typography
                            className="typographyLink"
                            onClick={() => {
                              this.setState({ priceplanItem: "Basic" });
                              this.handleClickOpenDialog(
                                "priceplanDetailDialog"
                              );
                            }}
                          >
                            View All Features...
                          </Typography>
                        ) : null}

                        <div
                          style={{
                            borderBottom: "1px solid #cccccc69",
                            paddingBottom: "12px",
                            marginBottom: "10px"
                          }}
                        />
                        <div style={{ display: "grid" }}>
                          <Typography>
                            <span style={{ float: "left" }}>
                              {this.state.subscription.brokers.basic ===
                              this.state.currentSubscription.brokers.basic
                                ? "Current Price:"
                                : "Updated Price:"}
                            </span>
                            <span style={{ float: "right" }}>
                              <strong>
                                R{this.state.subscription.amounts.basic}
                              </strong>
                            </span>
                          </Typography>
                          {this.state.subscription.brokers.basic <
                          this.state.currentSubscription.brokers.basic ? (
                            <Typography style={{ color: "orange" }}>
                              *NB: Selected changes will take effect after next
                              Debit Order Date
                            </Typography>
                          ) : null}
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={4} style={{ height: "88%" }}>
                  <Card>
                    <CardHeader>
                      <SpaceDisplay
                        left={
                          <Typography variant="subheading" gutterBottom>
                            Standard
                          </Typography>
                        }
                        right={
                          <Typography variant="caption" gutterBottom>
                            R
                            {
                              priceTableFirst12[
                                "level" + this.state.subscription.currentLevel
                              ].standard
                            }{" "}
                            p/m
                          </Typography>
                        }
                      />
                    </CardHeader>
                    <CardContent>
                      <div style={{ display: "block" }}>
                        <SpaceDisplay
                          style={{
                            borderBottom: "1px solid #cccccc69",
                            paddingBottom: "12px",
                            marginBottom: "10px"
                          }}
                          left={
                            <Typography
                              style={{
                                position: "relative",
                                top: "5px"
                              }}
                            >
                              Amount of brokers:
                            </Typography>
                          }
                          right={
                            <EasyRange
                              number={this.state.subscription.brokers.standard}
                              change={e =>
                                this.brokerAmountChange(e, "standard")
                              }
                              plus={() => this.brokerPlus("standard")}
                              minus={() => this.brokerMinus("standard")}
                            />
                          }
                        />
                        <Typography variant="body2" gutterBottom>
                          Includes:
                        </Typography>
                        <Typography>
                          {pricePlans.Standard.slice(0, 3).map(p => {
                            return (
                              <span>
                                {p}
                                <br />
                              </span>
                            );
                          })}
                        </Typography>

                        {pricePlans.Standard.length > 3 ? (
                          <Typography
                            className="typographyLink"
                            onClick={() => {
                              this.setState({ priceplanItem: "Standard" });
                              this.handleClickOpenDialog(
                                "priceplanDetailDialog"
                              );
                            }}
                          >
                            View All Features...
                          </Typography>
                        ) : null}

                        <div
                          style={{
                            borderBottom: "1px solid #cccccc69",
                            paddingBottom: "12px",
                            marginBottom: "10px"
                          }}
                        />
                        <div style={{ display: "grid" }}>
                          <Typography>
                            <span style={{ float: "left" }}>
                              {this.state.subscription.brokers.standard ===
                              this.state.currentSubscription.brokers.standard
                                ? "Current Price:"
                                : "Updated Price:"}
                            </span>
                            <span style={{ float: "right" }}>
                              <strong>
                                R{this.state.subscription.amounts.standard}
                              </strong>
                            </span>
                          </Typography>
                          {this.state.subscription.brokers.standard <
                          this.state.currentSubscription.brokers.standard ? (
                            <Typography style={{ color: "orange" }}>
                              *NB: Selected changes will take effect after next
                              Debit Order Date
                            </Typography>
                          ) : null}
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={4} style={{ height: "88%" }}>
                  <Card>
                    <CardHeader>
                      <SpaceDisplay
                        left={
                          <Typography variant="subheading" gutterBottom>
                            Premium
                          </Typography>
                        }
                        right={
                          <Typography variant="caption" gutterBottom>
                            R
                            {
                              priceTableFirst12[
                                "level" + this.state.subscription.currentLevel
                              ].premium
                            }{" "}
                            p/m
                          </Typography>
                        }
                      />
                    </CardHeader>
                    <CardContent>
                      <div style={{ display: "block" }}>
                        <Typography>Coming Soon!</Typography>

                        <div
                          style={{
                            borderBottom: "1px solid #cccccc69",
                            paddingBottom: "12px",
                            marginBottom: "10px",
                            paddingTop: "18px"
                          }}
                        />

                        <Typography variant="body2" gutterBottom>
                          Includes:
                        </Typography>
                        <Typography>
                          {pricePlans.Premium.slice(0, 3).map(p => {
                            return (
                              <span>
                                {p}
                                <br />
                              </span>
                            );
                          })}
                        </Typography>

                        {pricePlans.Premium.length > 3 ? (
                          <Typography
                            className="typographyLink"
                            onClick={() => {
                              this.setState({ priceplanItem: "Premium" });
                              this.handleClickOpenDialog(
                                "priceplanDetailDialog"
                              );
                            }}
                          >
                            View All Features...
                          </Typography>
                        ) : null}

                        <div
                          style={{
                            borderBottom: "1px solid #cccccc69",
                            paddingBottom: "12px",
                            marginBottom: "10px"
                          }}
                        />
                        <div style={{ display: "grid" }}>
                          <Typography>
                            <span style={{ float: "left" }}>
                              Current Price:
                            </span>
                            <span style={{ float: "right" }}>
                              <strong>
                                {" "}
                                R{this.state.subscription.amounts.premium}
                              </strong>
                            </span>
                          </Typography>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <Card>
                    <CardContent>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                          <div
                            style={{
                              display: "grid",
                              marginBottom: "10px"
                            }}
                          >
                            <Typography>
                              <span style={{ float: "left" }}>
                                Free Assistants:
                              </span>
                              <span
                                style={{
                                  float: "right",
                                  marginRight: "50px",
                                  fontSize: "1rem"
                                }}
                              >
                                {this.state.subscription.freeAssistants}
                              </span>
                            </Typography>
                          </div>

                          <SpaceDisplay
                            style={{
                              borderBottom: "1px solid #cccccc69",
                              paddingBottom: "12px",
                              marginBottom: "10px"
                            }}
                            left={
                              <Typography
                                style={{
                                  position: "relative",
                                  top: "5px"
                                }}
                              >
                                Extra Assistants:
                              </Typography>
                            }
                            right={
                              <EasyRange
                                number={this.state.subscription.extraAssistants}
                                change={e => this.extraAssistantAmountChange(e)}
                                plus={() => this.extraAssistantsPlus()}
                                minus={() => this.extraAssistantsMinus()}
                              />
                            }
                          />
                          <SpaceDisplay
                            left={<Typography>Grand Total:</Typography>}
                            right={
                              <Typography
                                style={{
                                  marginRight: "25px"
                                }}
                              >
                                <strong
                                  style={{
                                    fontSize: "1rem"
                                  }}
                                >
                                  R{this.state.subscription.totalPrice}{" "}
                                </strong>
                                P/M
                              </Typography>
                            }
                          />
                          {this.state.subscription
                            .within_twelve_month_period ? (
                            <SpaceDisplay
                              left={<Typography />}
                              right={
                                <Typography
                                  style={{
                                    marginRight: "25px"
                                  }}
                                >
                                  <span
                                    style={{
                                      marginRight: "15px"
                                    }}
                                  >
                                    After{" "}
                                    {this.state.subscription.twelth_month_date}{" "}
                                    :
                                  </span>
                                  <strong
                                    style={{
                                      fontSize: "1rem"
                                    }}
                                  >
                                    R{this.state.subscription.totalPriceAfter12}{" "}
                                  </strong>
                                  P/M
                                </Typography>
                              }
                            />
                          ) : null}
                          {this.state.subscription.payment.next &&
                          this.state.subscription.totalPrice >
                            this.state.currentSubscription.totalPrice ? (
                            <SpaceDisplay
                              left={<Typography />}
                              right={
                                <Typography
                                  style={{
                                    marginRight: "25px"
                                  }}
                                >
                                  <span
                                    style={{
                                      marginRight: "15px"
                                    }}
                                  >
                                    Next Debit Order Amount:
                                  </span>
                                  <strong
                                    style={{
                                      fontSize: "1rem"
                                    }}
                                  >
                                    R{this.getNextDebitOrderAmount()}{" "}
                                  </strong>
                                </Typography>
                              }
                            />
                          ) : null}
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12} />
                      </GridContainer>
                    </CardContent>
                  </Card>
                </GridItem>
                <GridItem
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ textAlign: "center" }}
                >
                  {this.differenceExists() ? (
                    <Button variant="contained" color="secondary">
                      CONFIRM CHANGES
                    </Button>
                  ) : null}
                </GridItem>
              </GridContainer>

              <Dialog
                open={this.state.priceplanDetailDialog}
                onClose={() => this.handleCloseDialog("priceplanDetailDialog")}
                aria-labelledby="form-dialog-title"
              >
                <DialogTitle id="form-dialog-title">
                  {this.state.priceplanItem} Package Features
                </DialogTitle>
                <DialogContent>
                  <Typography>
                    {pricePlans[this.state.priceplanItem].map(p => {
                      return (
                        <span>
                          {p}
                          <br />
                        </span>
                      );
                    })}
                  </Typography>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() =>
                      this.handleCloseDialog("priceplanDetailDialog")
                    }
                    color="primary"
                  >
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
            </React.Fragment>
          );
        }}
      </Query>
    );
  }
}

export default EditSubscription;



// WEBPACK FOOTER //
// ./src/views/Subscription/EditSubscription.jsx